export enum EUserPortfolioQueryKey {
  USER_PORTFOLIO = 'user-portfolio',
  USER_PORTFOLIO_TIME_SERIES = 'user-portfolio-time-series',
  WALLET_PORTFOLIO_CHART = 'wallet-portfolio-chart',
  USER_PERFORMANCE = 'user-performance',
}
